import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';
import { toggleFreefundCodeForm, togglePromoCodeForm, } from '../PaymentActions';
import './addmoney.css';
import AddMoneyForm from './AddMoneyForm';
import cuid from 'cuid';

const mapState = state => ({
  payment: state.payment,
  auth: state.auth,
  async: state.async,
  showFreefundCode: state.payment && state.payment.showFreefundCode,
  showPromoCode: state.payment && state.payment.showPromoCode,
});

const actions = {
  toggleFreefundCodeForm,
  togglePromoCodeForm,
};

class AddMoneyContainer extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired,
    payment: PropTypes.object,
    showFreefundCode: PropTypes.bool,
    showPromoCode: PropTypes.bool,
    toggleFreefundCodeForm: PropTypes.func.isRequired,
    togglePromoCodeForm: PropTypes.func.isRequired,
  };

  state = { addMoneyFormKey: cuid() };

  update = () => {
    this.setState({ addMoneyFormKey: cuid() });
  };

  //Hide Freefund and promocode if clicked outside the fields.
  hideDiscountCodeFields = () => {
    const { showFreefundCode, showPromoCode, toggleFreefundCodeForm, togglePromoCodeForm } = this.props;

    if (showFreefundCode) toggleFreefundCodeForm();
    if (showPromoCode) togglePromoCodeForm();
  }

  render() {
    const { auth, history } = this.props;
    return (
      <React.Fragment>
        <div id="add-money-feature" onClick={this.hideDiscountCodeFields}>
          {/* <Header as="h1">
            Add Money {'  '}{' '}
            <Loader
              active={async.key === 'addmoneyinit' && async.loading}
              inline
              size="tiny"
            />
          </Header> */}
          {auth.isLoggedIn && auth.isLoggedIn.kycWalletState === 'NO_KYC' && auth.isLoggedIn.kycActionRequired !== 'NO_ACTION_REQUIRED' && (
            <Label
              basic
              content="Please complete KYC before adding money to your wallet"
              color="blue"
            />
          )}
          <AddMoneyForm
            history={history}
            key={this.state.addMoneyFormKey}
            update={this.update}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  mapState,
  actions
)(AddMoneyContainer);
